import {Button, Input} from 'antd';
import {FormInstance} from 'antd/es/form/Form';
import {InputProps} from 'antd/es/input';
import React, {ChangeEvent, FC, memo, useCallback} from 'react';

import {showMessageFromResponse} from 'shared/utils';

import {PostButtonService} from '../service/input-with-post-button.service';
import s from './input-with-post-button.module.less';

interface IInputWithPostButton extends InputProps {
    formInstance: FormInstance;
    fieldKey: string | number;
    url: string;
    buttonTitle?: string;
}

export const InputWithPostButton: FC<IInputWithPostButton> = memo(
    ({
        formInstance,
        fieldKey,
        buttonTitle,
        url,
        ...props
    }: IInputWithPostButton) => {
        const handleClick = useCallback(async () => {
          try {
            await formInstance.validateFields([fieldKey]);
            const fieldValue = PostButtonService.getFieldValue({form: formInstance, fieldKey});
            const {response, isError} = await PostButtonService.saveAction({
              url,
              fieldKey,
              fieldValue
            })

            showMessageFromResponse({response, isError});
          } catch (e) {
            console.error('Возникла ошибка при валидации формы: ', e);
          }
        }, [formInstance, fieldKey]);

        const handleChange = useCallback(
          (e: ChangeEvent<HTMLInputElement>) => {
            formInstance.setFieldsValue({ [fieldKey]: e.target.value });
          },
          [formInstance, fieldKey],
        );

        return (
            <div className={s.wrapper}>
                <Input
                  value={formInstance.getFieldValue(fieldKey)}
                  onChange={handleChange}
                  defaultValue={props.defaultValue}
                  disabled={props.disabled}
                  placeholder={props.placeholder}
                />

                <Button type="primary" onClick={handleClick}>
                    {buttonTitle ?? 'Сохранить'}
                </Button>
            </div>
        );
    },
    (prev, next) =>
        prev.buttonTitle === next.buttonTitle &&
        prev.fieldKey === next.fieldKey &&
        prev.disabled === next.disabled &&
        prev.placeholder === next.placeholder,
);